// extracted by mini-css-extract-plugin
export default {"loaderParent":"Loader_loaderParent__U+HHv","loader":"Loader_loader__j0Tkq","spin":"Loader_spin__8TnK+"};